import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import { groupBy } from 'lodash'
import moment from 'moment';
import { stat } from 'fs';
// import moment from 'moment';

interface TransportCostsList {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
    accepts: any[];
    active_accept: any;
    schema: any;

    meta: any;
}

const state: TransportCostsList = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
    accepts: [],
    active_accept: {},
    schema: null,

    meta: {},
};

export const ITEMS_LIST = 'GET_TRANSPORT_COSTS_LIST';
export const ACCEPTS_LIST = 'GET_ACCEPTS_LIST';

export const actions: ActionTree<TransportCostsList, RootState> = {
    loadData({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const columns: any = {
                "id": "tcost.id",
                "delivery_zone_group_name": "dzone.name",
                "date": "tcost.date",
                "costs": "tcost.costs",
                "created_at": "tcost.created_at",
                "purpose": "tcost.purpose",
            };

            const filter: any[] = [];


            if (query.delivery_zone_group_id) {
                filter.push({ "$eq": ["tcost.delivery_zone_group_id", {"$": query.delivery_zone_group_id}] })
            }
            if (query.since) {
                filter.push({ "$gte": ["tcost.date", {"$": query.since}] })
            }
            if (query.until) {
                filter.push({ "$lte": ["tcost.date", {"$": query.until}] })
            }

            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('documents.list')
                .action({
                    "columns": columns,
                    "from": "s:view_transport_costs_fourth_by_zone_group",
                    "from_as": "tcost",
                    "joins": [
                      {
                        "join": "s:delivery_zone_groups",
                        "type": "left",
                        "as":   "dzone",
                        "on": {
                          "$eq": ["tcost.delivery_zone_group_id", "dzone.id"]
                        }
                      }
                    ],
                    page_size: 10000,
                    ...({
                        order: [
                            query.sortDirection == 'asc' ? { $asc: [columns[query.sortField || 'date' ]] } : { $desc: [columns[query.sortField || 'date']] }
                        ]
                    }),
                    ...(
                        filter.length > 1 ?
                        {
                            "where": {
                                "$and": filter
                            }
                        } : {
                            "where": filter[0]
                        }
                    )

                }),
                vm.$q(ACCEPTS_LIST)
                .raw('documents.list')
                .action({
                    "columns": {
                        'id': 'tcost.id',
                        'is_accepted': 'tcost.is_accepted',
                        'month': 'tcost.month',
                        'manager_name': 'e.name',
                        'created_at': 'tcost.created_at',
                    },
                    "from": "s:transport_costs_accepts",
                    "from_as": "tcost",
                    "joins": [
                      {
                        "join": "s:employees",
                        "type": "left",
                        "as":   "e",
                        "on": {
                          "$eq": ["tcost.manager_id", "e.id"]
                        }
                      }
                    ],
                    page_size: 10000,
                    "where": { "$gte": ["tcost.month", {"$": moment().format('YYYY-01-01')}] }

                }),
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());
                commit('SET_ACCEPTS_LIST', result.getOperation(ACCEPTS_LIST).getContent());
                commit('LOADED_SUCCESS');

                resolve(null);
            }));
        })
    },

    deleteTransportCost({ commit, getters, dispatch }, {id}) {
        const vm = (this as any)._vm;
        console.log(id)
        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('documents.delete')
                .action({id})
            ]).then(((result: ServerResult) => {
                resolve(null);
            }))
        })
    },

    setActiveAccept({state, getters}, month) {
        state.active_accept = getters.byMonthy[month]
    },

    acceptMonth ({state, rootState}) {
        const vm = (this as any)._vm;

        if (!state.active_accept || !state.active_accept.id) {
            state.active_accept = {
                ...state.active_accept,
                is_accepted: true,
                manager_id: (rootState as any).ubic.actor.document.id
            }
        }
        const query = state.active_accept.id ?
            vm.$q('SAVE_TRANSPORT_COSTS_ACCEPTS').update(state.active_accept.id, state.active_accept) :
            vm.$q('SAVE_TRANSPORT_COSTS_ACCEPTS').create('transport_costs_accepts', state.active_accept);

        return new Promise((resolve, reject) => {
            vm.$db([
                query
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('SAVE_TRANSPORT_COSTS_ACCEPTS');

                if (operationResult.hasError()) {
                    reject();
                } else {
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        })
    }

};

export const mutations: MutationTree<TransportCostsList> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_ACCEPTS_LIST(state, data) {
        state.accepts = data.documents
        state.active_accept = data.documents[0]
    },

    SET_ITEMS_LIST(state, data) {
        const documents: any = {}
        // @ts-ignore
        data.documents.map((item: any) => {
            const key = `${item.delivery_zone_group_name}-${item.date}`
            if (!documents[key]) {
                documents[key] = {
                    id: key,
                    delivery_zone_group_name: item.delivery_zone_group_name,
                    date: item.date,
                    costs: 0,
                    items: []
                }
            }
            item.costs = parseFloat(item.costs)
            item.id = item.id ? `d:transport_costs:${item.id}` : item.id
            documents[key].costs += item.costs
            documents[key].items.push(item)
        })

        state.documents = Object.values(documents)

        state.schema = data.schema;
        state.meta = fetchEnumsFromSchema(data.schema);
        console.log(state.meta)

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
};

const getters = {
    byMonthy: (state: TransportCostsList) => {
        const accepts: any = {
            0: {month: moment().format('YYYY-01-01')},
            1: {month: moment().format('YYYY-02-01')},
            2: {month: moment().format('YYYY-03-01')},
            3: {month: moment().format('YYYY-04-01')},
            4: {month: moment().format('YYYY-05-01')},
            5: {month: moment().format('YYYY-06-01')},
            6: {month: moment().format('YYYY-07-01')},
            7: {month: moment().format('YYYY-08-01')},
            8: {month: moment().format('YYYY-09-01')},
            9: {month: moment().format('YYYY-10-01')},
            10: {month: moment().format('YYYY-11-01')},
            11: {month: moment().format('YYYY-12-01')},
        }

        state.accepts.map((item: any) => {
            accepts[parseInt(moment(item.month).format('MM')) - 1] = item
        })

        return accepts
    }
};

export const STORE_KEY = '$_employee_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
